import { ShieldCheckOutlineIcon } from './ShieldCheckOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 26E9DF2C-21C8-48FF-B402-733E33673C7E
 * name shield-check-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-check-outline.svg
 * tags
 */
export const ShieldTickOutlineIcon = ShieldCheckOutlineIcon;
export default ShieldTickOutlineIcon